import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../shared/hooks/http-hook";

import { AuthContext } from "../../shared/context/auth-context";
//mui icons

import "../../style/formError.scss";
import "./Configuracoes.scss";
import CategoriasFinanceiro from "./categoriasFinanceiro/CategoriasFinanceiro";
import CategoriasStock from "./categoriasStock/CategoriasStock";
import Caixas from "./caixas/Caixas";
import Unidades from "./unidades/Unidades";
import Permissoes from "./permissoes/Permissoes";
import CategoriasTratamento from "./categoriasTratamento/CategoriasTratamento";
import ClientesFinanceiros from "./clientesFinanceiros/ClientesFinanceiros";
import DespesasRecorrentes from "./despesasRecorrentes/DespesasRecorrentes";

import { ClinicaContext } from "../../shared/context/clinica-context";
import Outras from "./outras/Outras";
import Portal from "./portal/Portal";
import MarcacaoOnline from "./marcacaoOnline/MarcacaoOnline";

import SettingsIcon from "@mui/icons-material/Settings";
import Fornecedores from "./fornecedores/Fornecedores";
import Instituicoes from "./instituicoes/Instituicoes";
import Shortcuts from "./shortcuts/Shortcuts";
import EmpresasParceiras from "./empresasParceiras/EmpresasParceiras";
import ComunicacaoTemplates from "./comunicacaoTemplates/ComunicacaoTemplates";

const configuracoesIcon = SettingsIcon;
function Configuracoes() {
  const [showMainTabs, setShowMainTabs] = useState();

  const { sendRequest } = useHttpClient();

  const temporary = useParams().aba;

  const auth = useContext(AuthContext);
  const clinicaCtx = useContext(ClinicaContext);
  const clinicaId = clinicaCtx.clinica._id;
  // A aba das Unidades só existe em clínicas com mais do que uma.
  const multiUnidade = !!clinicaCtx.clinica?.multiEstabelecimento;

  useEffect(() => {
    const aba = temporary;
    if (aba) {
      setShowMainTabs(aba);
    } else {
      setShowMainTabs("permissoes");
    }
  }, [sendRequest, temporary, auth.token]);

  return (
    <>
      <div className="new">
        <Sidebar />
        <div className="newContainer">
          <Navbar title="Configurações" icon={configuracoesIcon} />

          <div className="configuracoes__container">
            <div className="configuracoes__menuLateral">
              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "shortcuts" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("shortcuts")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "shortcuts" && "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("shortcuts")}
                >
                  Atalhos
                </span>
              </div>
              {(auth.role === "Médico/Administrador" ||
                auth.role === "Gerente") && (
                <div
                  className={`configuracoes__menuLateral__item ${
                    showMainTabs === "permissoes" &&
                    "configuracoes__menuLateral__item--active"
                  }`}
                  onClick={() => setShowMainTabs("permissoes")}
                >
                  <span
                    className={`aba__configuracoes ${
                      showMainTabs === "permissoes" &&
                      "aba__configuracoes--active"
                    }`}
                    onClick={() => setShowMainTabs("permissoes")}
                  >
                    Permissões
                  </span>
                </div>
              )}

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "categoriasTratamento" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("categoriasTratamento")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "categoriasTratamento" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("categoriasTratamento")}
                >
                  Categorias Tratamento
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "categoriasFinanceiro" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("categoriasFinanceiro")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "categoriasFinanceiro" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("categoriasFinanceiro")}
                >
                  Categorias Financeiro
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "categoriasStock" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("categoriasStock")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "categoriasStock" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("categoriasStock")}
                >
                  Categorias Stock
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "caixas" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("caixas")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "caixas" && "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("caixas")}
                >
                  Caixas
                </span>
              </div>

              {/* Só nas clínicas com mais do que uma unidade, e só para quem
                  gere: criar unidades mexe na identidade fiscal (LED, série,
                  numeração). */}
              {multiUnidade &&
                (auth.role === "Médico/Administrador" ||
                  auth.role === "Gerente") && (
                  <div
                    className={`configuracoes__menuLateral__item ${
                      showMainTabs === "unidades" &&
                      "configuracoes__menuLateral__item--active"
                    }`}
                    onClick={() => setShowMainTabs("unidades")}
                  >
                    <span
                      className={` aba__configuracoes ${
                        showMainTabs === "unidades" &&
                        "aba__configuracoes--active"
                      }`}
                    >
                      Unidades
                    </span>
                  </div>
                )}

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "clientesFinanceiros" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("clientesFinanceiros")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "clientesFinanceiros" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("clientesFinanceiros")}
                >
                  Clientes-Financeiros
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "fornecedores" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("fornecedores")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "fornecedores" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("fornecedores")}
                >
                  Fornecedores
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "empresasParceiras" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("empresasParceiras")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "empresasParceiras" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("empresasParceiras")}
                >
                  Empresas Parceiras
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "fornecedores" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("instituicoes")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "instituicoes" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("instituicoes")}
                >
                  Instituições
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "despesasRecorrentes" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("despesasRecorrentes")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "despesasRecorrentes" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("despesasRecorrentes")}
                >
                  Saídas Recorrentes
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "comunicacaoTemplates" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("comunicacaoTemplates")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "comunicacaoTemplates" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("comunicacaoTemplates")}
                >
                  Templates de comunicação
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "portal" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("portal")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "portal" && "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("portal")}
                >
                  Portal do Paciente
                </span>
              </div>

              {/* A pagina PUBLICA de marcacoes, que e outra coisa do portal
                  com login: nao tem sessao e e por unidade. */}
              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "marcacaoonline" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("marcacaoonline")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "marcacaoonline" &&
                    "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("marcacaoonline")}
                >
                  Marcação online
                </span>
              </div>

              <div
                className={`configuracoes__menuLateral__item ${
                  showMainTabs === "outras" &&
                  "configuracoes__menuLateral__item--active"
                }`}
                onClick={() => setShowMainTabs("outras")}
              >
                <span
                  className={` aba__configuracoes ${
                    showMainTabs === "outras" && "aba__configuracoes--active"
                  }`}
                  onClick={() => setShowMainTabs("outras")}
                >
                  Outras
                </span>
              </div>
            </div>

            <div className="configuracoes__conteudo">
              {showMainTabs === "categoriasFinanceiro" && (
                <CategoriasFinanceiro
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}

              {showMainTabs === "fornecedores" && (
                <Fornecedores sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "categoriasStock" && (
                <CategoriasStock
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}

              {showMainTabs === "caixas" && (
                <Caixas sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "unidades" && (
                <Unidades sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "permissoes" && (
                <Permissoes sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "categoriasTratamento" && (
                <CategoriasTratamento
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}

              {showMainTabs === "clientesFinanceiros" && (
                <ClientesFinanceiros
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}

              {showMainTabs === "instituicoes" && (
                <Instituicoes sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "despesasRecorrentes" && (
                <DespesasRecorrentes
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}
              {showMainTabs === "empresasParceiras" && (
                <EmpresasParceiras
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}
              {showMainTabs === "comunicacaoTemplates" && (
                <ComunicacaoTemplates
                  sendRequest={sendRequest}
                  clinicaId={clinicaId}
                />
              )}

              {showMainTabs === "portal" && (
                <Portal sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "marcacaoonline" && (
                <MarcacaoOnline sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "outras" && (
                <Outras sendRequest={sendRequest} clinicaId={clinicaId} />
              )}

              {showMainTabs === "shortcuts" && (
                <Shortcuts sendRequest={sendRequest} clinicaId={clinicaId} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Configuracoes;
